import { render, staticRenderFns } from "./MessageCenterBox.vue?vue&type=template&id=63adffd1&scoped=true&"
import script from "./MessageCenterBox.vue?vue&type=script&lang=js&"
export * from "./MessageCenterBox.vue?vue&type=script&lang=js&"
import style0 from "./MessageCenterBox.vue?vue&type=style&index=0&id=63adffd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63adffd1",
  null
  
)

export default component.exports